import React, { useEffect, useState } from "react";
import { SuccessPopUp } from "../../../CommonComponents/SuccessPopUp";

function Setting() {

  const BASE_URL = process.env.REACT_APP_PP_URL;
  const token = sessionStorage.getItem('tokenKey');

  const [action, setAction] = useState();
  const [showPop, setShowPop] = useState(false);

  const confirm = () => {
    setShowPop(false);
  }

  const [list, setList] = useState({});

  const getData = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/v1/setting/setting-list`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        setList(getRes.responsePacket);

        setAndroidVersion(getRes.responsePacket?.floatSettings?.AppVersion);
        setPackingCharges(getRes.responsePacket?.floatSettings?.PackingCharges);
        setPackingWeight(getRes.responsePacket?.floatSettings?.PackingWeight);
        setCodCharges(getRes.responsePacket?.floatSettings?.CodCharges);

        setNotificationEmail(getRes.responsePacket.stringSettings?.SupportEmail);
        setSupportContactNo(getRes.responsePacket.stringSettings?.SupportContactNo);
        setCompanyAddress(getRes.responsePacket.stringSettings?.CompanyAddress);
        setHeaderAlertLine(getRes.responsePacket.stringSettings?.HeaderAlertLine);
        setInstagramUrl(getRes.responsePacket.stringSettings?.InstagramUrl);
        setYoutubeUrl(getRes.responsePacket.stringSettings?.YoutubeUrl);
        setTwitterUrl(getRes.responsePacket.stringSettings?.TwitterUrl);
        setFacebookUrl(getRes.responsePacket.stringSettings?.FacebookUrl);
        setTelegramUrl(getRes.responsePacket.stringSettings?.TelegramUrl);

        setToggleSettings(() => ({
          TestMode: +getRes.responsePacket.toggleSettings.TestMode,
          StaffLogin: +getRes.responsePacket.toggleSettings.StaffLogin,
          AdminLogin: +getRes.responsePacket.toggleSettings.AdminLogin,
          UnderMaintenance: +getRes.responsePacket.toggleSettings.UnderMaintenance,
          CashOnDelivery: +getRes.responsePacket.toggleSettings.CashOnDelivery,
        }));
        const parsedArray = JSON.parse(getRes.responsePacket.deliveryCharges?.settingValue); // Parse the JSON string
        setDeliveryJson(parsedArray ? parsedArray : []);
      }
    } catch (e) {
      console.log(e, 'error in getting data api')
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const [toggleSettings, setToggleSettings] = useState({
    TestMode: Number(list?.toggleSettings?.TestMode),
    StaffLogin: Number(list?.toggleSettings?.StaffLogin),
    UnderMaintenance: Number(list?.toggleSettings?.UnderMaintenance),
    CashOnDelivery: Number(list?.toggleSettings?.CashOnDelivery),
  });

  const updateToggleSetting = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/v1/setting/update-settings`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          {
            settings: [
              {
                settingKey: 'TestMode',
                settingValue: toggleSettings.TestMode,
              },
              {
                settingKey: 'StaffLogin',
                settingValue: toggleSettings.StaffLogin,
              },
              {
                settingKey: 'UnderMaintenance',
                settingValue: toggleSettings.UnderMaintenance,
              },
              {
                settingKey: 'CashOnDelivery',
                settingValue: toggleSettings.CashOnDelivery,
              },
            ]
          }
        )
      })
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        getData();
        setAction("Toggle Setting Updated");
        setShowPop(true);
      } else {
        setAction(getRes.message);
        setShowPop(true);
      }
    } catch (e) {
      console.log(e, 'error in update setting api')
    }
  };

  const handleToggle = (key) => {
    setToggleSettings((prev) => ({
      ...prev,
      [key]: prev[key] === 1 ? 0 : 1, // Toggle between 1 and 0
    }));
  };

  const [androidVersion, setAndroidVersion] = useState(list?.floatSettings?.AppVersion);
  const [PackingCharges, setPackingCharges] = useState(list?.floatSettings?.PackingCharges);
  const [PackingWeight, setPackingWeight] = useState(list?.floatSettings?.PackingWeight);
  const [CodCharges, setCodCharges] = useState(list?.floatSettings?.CodCharges);

  const updateFloatSetting = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/v1/setting/update-settings`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          settings: [
            {
              settingKey: "AppVersion",
              settingValue: androidVersion,
            },
            {
              settingKey: "PackingWeight",
              settingValue: PackingWeight
            },
            {
              settingKey: "PackingCharges",
              settingValue: PackingCharges
            },
            {
              settingKey: "CodCharges",
              settingValue: CodCharges
            },
          ]
        })
      })
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        getData();
        setAction(getRes.message);
        setShowPop(true);
      } else {
        setAction(getRes.message);
        setShowPop(true);
      }
    } catch (e) {
      console.log(e, 'error in updatein floARt setting')
    }
  };

  const [notificationEmail, setNotificationEmail] = useState(list?.stringSettings?.SupportEmail);
  const [SupportContactNo, setSupportContactNo] = useState(list?.stringSettings?.SupportContactNo);
  const [CompanyAddress, setCompanyAddress] = useState(list?.stringSettings?.CompanyAddress);
  const [HeaderAlertLine, setHeaderAlertLine] = useState(list?.stringSettings?.HeaderAlertLine);
  const [facebookUrl, setFacebookUrl] = useState(list?.stringSettings?.FacebookUrl);
  const [instagramUrl, setInstagramUrl] = useState(list?.stringSettings?.InstagramUrl);
  const [twitterUrl, setTwitterUrl] = useState(list?.stringSettings?.TwitterUrl);
  const [youtubeUrl, setYoutubeUrl] = useState(list?.stringSettings?.YoutubeUrl);
  const [TelegramUrl, setTelegramUrl] = useState(list?.stringSettings?.TelegramUrl);

  const updateStringSettings = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/v1/setting/update-settings`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          settings: [
            {
              settingKey: "SupportEmail",
              settingValue: notificationEmail,
            },
            {
              settingKey: "SupportContactNo",
              settingValue: SupportContactNo
            },
            {
              settingKey: "CompanyAddress",
              settingValue: CompanyAddress
            },
            {
              settingKey: "HeaderAlertLine",
              settingValue: HeaderAlertLine
            },
            {
              settingKey: "YoutubeUrl",
              settingValue: youtubeUrl
            },
            {
              settingKey: "InstagramUrl",
              settingValue: instagramUrl
            },
            {
              settingKey: "TwitterUrl",
              settingValue: twitterUrl
            },
            {
              settingKey: "FacebookUrl",
              settingValue: facebookUrl
            },
            {
              settingKey: "TelegramUrl",
              settingValue: TelegramUrl
            },
          ]
        })
      })
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        getData();
        setAction(getRes.message);
        setShowPop(true);
      } else {
        setAction(getRes.message);
        setShowPop(true);
      }
    } catch (e) {
      console.log(e, 'error in string setting update')
    }
  };

  const [deliveryJson, setDeliveryJson] = useState([
    {
      startWeight: '',
      endWeight: '',
      standardDeliveryCharges: '',
      expressDeliveryCharges: ''
    }
  ]);

  const AddFormJosn = () => {
    setDeliveryJson([
      ...deliveryJson, {
        startWeight: '',
        endWeight: '',
        standardDeliveryCharges: '',
        expressDeliveryCharges: ''
      }
    ]);
  };

  const removeJsonForm = (index) => {
    const filteredJson = deliveryJson.filter((_, i) => i !== index);
    setDeliveryJson(filteredJson);
  };

  const handleChangeJson = (index, e) => {
    const { name, value } = e.target;
    setDeliveryJson(prev =>
      prev.map((form, i) =>
        i === index ? { ...form, [name]: value } : form
      )
    )
  };

  const updateDeliveryCharges = async () => {
    try {
      const data = JSON.stringify(deliveryJson);
      const res = await fetch(`${BASE_URL}/admin/v1/setting/update-settings`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          settings: [
            {
              settingKey: "DeliveryChargeJson",
              settingValue: data,
            }
          ]
        })
      })
      const getRes = await res.json();
      if (getRes.errorCode === 0) {
        getData();
        setAction(getRes.message);
        setShowPop(true);
      } else {
        setAction(getRes.message);
        setShowPop(true);
      }
    } catch (e) {
      console.log(e, 'error in update delivery charges api ');
    }
  };

  return (
    <>
      <div className="main-container-setting">
        <div className="settings-page">
          <div className="settings-grid">
            <div className="settings-card">
              <h3>Toggle Settings</h3>

              <div className="toggle-item">
                <span>Test Mode</span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={toggleSettings["TestMode"] === 1}
                    onChange={() => handleToggle("TestMode")}
                  />
                  <span className="slider"></span>
                </label>
              </div>

              <div className="toggle-item">
                <span>Staff Login</span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={toggleSettings["StaffLogin"] === 1}
                    onChange={() => handleToggle("StaffLogin")}
                  />
                  <span className="slider"></span>
                </label>
              </div>

              <div className="toggle-item">
                <span>UnderMaintenance</span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={toggleSettings["UnderMaintenance"] === 1}
                    onChange={() => handleToggle("UnderMaintenance")}
                  />
                  <span className="slider"></span>
                </label>
              </div>

              <div className="toggle-item">
                <span>CashOnDelivery</span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={toggleSettings["CashOnDelivery"] === 1}
                    onChange={() => handleToggle("CashOnDelivery")}
                  />
                  <span className="slider"></span>
                </label>
              </div>

              <button className="submit-button" onClick={updateToggleSetting}>Submit Toggle Settings</button>
            </div>

            <div className="settings-card">
              <h3>Float Settings</h3>
              <label>Customer App Version:</label>
              <input
                type="text"
                value={androidVersion}
                onChange={(e) => setAndroidVersion(e.target.value)}
              />

              <label>Packing Charges:</label>
              <input
                type="text"
                value={PackingCharges}
                onChange={(e) => setPackingCharges(e.target.value)}
              />

              <label>COD Charges:</label>
              <input
                type="text"
                value={CodCharges}
                onChange={(e) => setCodCharges(e.target.value)}
              />

              <label>Packing Weight (in gm):</label>
              <input
                type="text"
                value={PackingWeight}
                onChange={(e) => setPackingWeight(e.target.value)}
              />
              <button className="submit-button" onClick={updateFloatSetting}>Submit Float Settings</button>
            </div>

            <div className="settings-card settings-card-a">
              <h3>String Settings</h3>
              <div>
                <label>Support Email To:</label>
                <input
                  type="text"
                  value={notificationEmail}
                  onChange={(e) => setNotificationEmail(e.target.value)}
                />
                <label>Support Contact No:</label>
                <input
                  type="number"
                  value={SupportContactNo}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setSupportContactNo(e.target.value)}
                />
                <label>Company Address:</label>
                <input
                  type="text"
                  value={CompanyAddress}
                  onChange={(e) => setCompanyAddress(e.target.value)}
                />
                <label>Header Alert Line:</label>
                <input
                  type="text"
                  value={HeaderAlertLine}
                  onChange={(e) => setHeaderAlertLine(e.target.value)}
                />
                <label>Facebook URL:</label>
                <input
                  type="text"
                  value={facebookUrl}
                  onChange={(e) => setFacebookUrl(e.target.value)}
                />
                <label>Instagram URL:</label>
                <input
                  type="text"
                  value={instagramUrl}
                  onChange={(e) => setInstagramUrl(e.target.value)}
                />
                <label>Youtube URL:</label>
                <input
                  type="text"
                  value={youtubeUrl}
                  onChange={(e) => setYoutubeUrl(e.target.value)}
                />
                <label>Twitter URL:</label>
                <input
                  type="text"
                  value={twitterUrl}
                  onChange={(e) => setTwitterUrl(e.target.value)}
                />
                <label>Telegram URL:</label>
                <input
                  type="text"
                  value={TelegramUrl}
                  onChange={(e) => setTelegramUrl(e.target.value)}
                />
              </div>
              <button className="submit-button" onClick={updateStringSettings}>Submit String Settings</button>
            </div>

            <div className="settings-card">
              <h3>Delivery Charges</h3>
              {
                deliveryJson?.map((itm, index) => {
                  return (
                    <>
                      <div className="add-field m-t2">
                        <button onClick={() => removeJsonForm(index)}>-Remove</button>
                      </div>
                      <div>
                        <label>Start Weight (in gm)</label>
                        <input
                          type="number"
                          name="startWeight"
                           onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                          value={itm.startWeight}
                          onChange={(e) => handleChangeJson(index, e)}
                        />

                        <label>End Weight (in gm)</label>
                        <input
                          type="number"
                          name="endWeight"
                           onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                          value={itm.endWeight}
                          onChange={(e) => handleChangeJson(index, e)}
                        />

                        <label>Standerd Delivery Charges</label>
                        <input
                          type="number"
                           onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                          name="standardDeliveryCharges"
                          value={itm.standardDeliveryCharges}
                          onChange={(e) => handleChangeJson(index, e)}
                        />

                        <label>Express Delivery Charges</label>
                        <input
                          type="number"
                           onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                          name="expressDeliveryCharges"
                          value={itm.expressDeliveryCharges}
                          onChange={(e) => handleChangeJson(index, e)}
                        />
                      </div>
                    </>
                  )
                })
              }
              <div className="add-field">
                <button onClick={AddFormJosn}>+Add More</button>
              </div>
              <button className="submit-button" onClick={updateDeliveryCharges}>Submit Delivery Charges</button>
            </div>
          </div>
        </div>
      </div>
      <SuccessPopUp
        isOpen={showPop}
        action={action}
        navv={"ok"}
        onConfirm={confirm}
      />
    </>
  )
}
export default Setting;